import { createSlice } from "@reduxjs/toolkit";
import {
  getSemesterDataByGroupId,
  getStudentDiary,
  getStudentParent,
  getStudentSchedule,
  getAttendanceScheduleDates,
  getStudentSubjectMarks,
  getStudentControlByParent,
} from "./api";

const initialState = {
  loading: false,
  parentStudents: [],
  studentDiary: [],
  studentSchedule: [],

  journalSelectedSemester: null,
  student: JSON.parse(sessionStorage.getItem("student")),

  semesterDataByGroupId: [],
  studentSubjectMarks: [],
  journalDates: [],
  studentControlDataByParent: null,
};

const parentSlice = createSlice({
  name: "parent",
  initialState,
  reducers: {
    setJournalSelectedSemester: (state, action) => {
      state.journalSelectedSemester = action.payload;
    },

    setStudent: (state, action) => {
      state.student = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getStudentParent.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(getStudentParent.fulfilled, (state, action) => {
      state.loading = false;
      state.parentStudents = action.payload;
    });
    builder.addCase(getStudentParent.rejected, (state, action) => {
      state.loading = false;
    });

    builder.addCase(getStudentDiary.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(getStudentDiary.fulfilled, (state, action) => {
      state.loading = false;
      state.studentDiary = action.payload;
    });
    builder.addCase(getStudentDiary.rejected, (state, action) => {
      state.loading = false;
    });

    builder.addCase(getStudentSchedule.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(getStudentSchedule.fulfilled, (state, action) => {
      state.loading = false;
      state.studentSchedule = action.payload;
    });
    builder.addCase(getStudentSchedule.rejected, (state, action) => {
      state.loading = false;
    });

    builder.addCase(getAttendanceScheduleDates.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(getAttendanceScheduleDates.fulfilled, (state, action) => {
      state.loading = false;
      state.journalDates = action.payload;
    });
    builder.addCase(getAttendanceScheduleDates.rejected, (state, action) => {
      state.loading = false;
    });

    builder.addCase(getSemesterDataByGroupId.fulfilled, (state, action) => {
      state.semesterDataByGroupId = action.payload;
    });

    builder.addCase(getStudentSubjectMarks.fulfilled, (state, action) => {
      state.studentSubjectMarks = action.payload;
    });

    builder.addCase(getStudentControlByParent.fulfilled, (state, action) => {
      state.studentControlDataByParent = action.payload;
    });
  },
});

export const { setJournalSelectedSemester, setStudent } = parentSlice.actions;

export default parentSlice.reducer;
